import { SEmptyData } from './emptyData.styled'

export const EmptyData = () => <SEmptyData>Здесь пока еще пусто</SEmptyData>
